import { useMutation, useQueryClient } from "@tanstack/react-query";
import { partyLicensesKeys } from "Api/Queries/Licenses/usePartyLicensesQuery";
import { postInvoicesLicenseLicensePublicIDSend } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Variables = {
  licensePublicID: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useSendLicenseInvoiceMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ licensePublicID }: Variables) =>
        postInvoicesLicenseLicensePublicIDSend(licensePublicID),
    ),

    onSuccess: (_data, { licensePublicID }: Variables) => {
      queryClient.invalidateQueries({
        queryKey: partyLicensesKeys.byPartyPublicId(licensePublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
